export default "__VITE_ASSET__c81c860a__"